import Button from "../../components/button";
import { Table } from "../../components/ui/table";
import AddIcon from "../../components/icons/add-icon";
import FilterIcon from "../../components/icons/filter-icon";
import Popover from "@mui/material/Popover";
import { useEffect, useMemo, useState } from "react";
import ViewIcon from "../../components/icons/view-icon";
import DeleteIcon from "../../components/icons/delete-icon";
import ConfirmationCard from "../../components/ui/confirmation-card";
import Modal from "../../components/ui/modal";
import CardDetail from "../../components/cardDetail/cardDetail";
import { useNavigate } from "react-router-dom";
import { getCards, getCardsCount } from "src/firebase/admin.js";
import { deleteDoc, doc } from "firebase/firestore";
import { handleToastMessage } from "src/js/handleToastMessage";
import { db } from "src/firebase/firebase";
import { useTranslation } from "react-i18next";
import editIcon from "../../assets/images/editing.png";
import refreshImage from "../../assets/images/refresh.png";
import { dateSorting } from "src/js/sorting";
import { Pagination } from "@mui/material";
import OverlayLoader from "../../components/overlayLoader";
import Input from "../../components/input";

const pageSize = 200;

const CardManagement = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [activeDeletedId, setActiveDeletedId] = useState<string>("");
  const [activeCardDetail, setActiveCardDetail] = useState(null);
  const [cardList, setCardList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation(["home"]);
  const [totalCards, setTotalCards] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchText, setSearchText] = useState<string>("");

  const allowCardSubmit = useMemo(() => {
    const userData = localStorage.getItem("account");
    const userData1 = JSON.parse(userData ?? "");
    const allow = userData1?.allowCardSubmit === false ? false : true;
    return allow;
  }, [localStorage.getItem("account")]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  useEffect(() => {
    getCardListCount();
  }, []);

  useEffect(() => {
    getCardList();
  }, [currentPage, searchText]);

  const getCardListCount = async () => {
    const accoount = JSON.parse(await localStorage.getItem("account"));
    let result: any = await getCardsCount(accoount.id, "");

    console.log("result", result);
    setTotalCards(result);
  };

  const getCardList = async () => {
    setIsLoading(true);
    const accoount = JSON.parse(await localStorage.getItem("account"));
    let result: any = await getCards(
      accoount.id,
      "",
      currentPage,
      pageSize,
      searchText
    );

    setIsLoading(false);
    let _cardList = dateSorting(result ?? [], "date");
    setCardList(_cardList);
  };

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    console.log("value", page);
    setCurrentPage(page);
  };

  const navigate = useNavigate();
  const columns = [
    // {
    //   title: (
    //     <div className="pl-1 flex justify-between items-center">
    //       <span>{t("ID")}</span>
    //     </div>
    //   ),
    //   dataIndex: "id",
    //   key: "id",
    //   width: 200,
    // },

    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Card No")}</span>
        </div>
      ),
      dataIndex: "cardNo",
      key: "cardNo",
      width: 200,
      render: (cardNo: string) => <div>{cardNo}</div>,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Cvv")}</span>
        </div>
      ),
      dataIndex: "cvv",
      key: "cvv",
      width: 200,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("MM/YY")}</span>
        </div>
      ),
      dataIndex: "mmyy",
      key: "mmyy",
      width: 200,
    },

    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Amount")}</span>
        </div>
      ),
      dataIndex: "amount",
      key: "amount",
      width: 200,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Rate")}</span>
        </div>
      ),
      dataIndex: "rate",
      key: "rate",
      width: 200,
    },
    // {
    //   title: (
    //     <div className="pl-1 flex justify-between items-center">
    //       <span>{t("Order")}</span>
    //     </div>
    //   ),
    //   dataIndex: "order",
    //   key: "order",
    //   width: 200,
    // },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Date")}</span>
        </div>
      ),
      dataIndex: "date",
      render: (date: any) => (
        <div>{date ? new Date(date.seconds * 1000).toDateString() : ""}</div>
      ),
      key: "date",
      width: 200,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Status")}</span>
        </div>
      ),
      dataIndex: "status",
      key: "status",
      width: 200,
      render: (status: string) => (
        <div>
          {status === "pending activation" && (
            <span className="py-1 px-3 bg-warn text-warn-700 rounded inline-block w-[100px] text-center ">
              {t("Pending activation")}
            </span>
          )}
          {status === "pending" && (
            <span className="py-1 px-3 bg-warn text-warn-700 rounded inline-block w-[70px] text-center ">
              {t("Pending")}
            </span>
          )}
          {status === "paid" && (
            <span className="py-1 px-3 bg-success-100 text-success rounded inline-block w-[70px] text-center ">
              {t("Paid")}
            </span>
          )}
          {status === "declined" && (
            <span className="py-1 px-3 bg-red-100 text-red rounded inline-block text-center w-[70px]">
              {t("Declined")}
            </span>
          )}
        </div>
      ),
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Action")}</span>
        </div>
      ),
      dataIndex: "id",
      key: "id",
      width: 200,
      render: (id: string, row: any) => (
        <div className="flex gap-x-2">
          <ViewIcon
            className="cursor-pointer"
            onClick={() => setActiveCardDetail(row)}
          />
          {/* <DeleteIcon
            className="cursor-pointer"
            onClick={() => setActiveDeletedId(id)}
          /> */}
          {/* <img
            src={editIcon}
            className="cursor-pointer"
            onClick={() => navigate(`/supplier/new-card?id=${id}`)}
          /> */}
        </div>
      ),
    },
  ];
  const handleDelete = () => {
    const docRef = doc(db, "Cards", activeDeletedId);
    deleteDoc(docRef).then((res) => {
      handleToastMessage("success", "Delete card successfully");
      setActiveDeletedId("");
      getCardList();
    });
  };

  const getStatusCardList = async (status) => {
    setIsLoading(true);
    const accoount = JSON.parse(await localStorage.getItem("account"));
    let result: any = await getCards(accoount.id, status);
    setIsLoading(false);

    setCardList(result ?? []);
  };
  const handleCardSearch = (value) => {
    setSearchText(value);
    setCurrentPage(1);
  };
  return (
    <div className="p-5">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-xl text-darkBlack font-semibold">
          {t("Cards")} {t("Management")}
        </h2>
        {allowCardSubmit && (
          <Button
            className="ml-0 block"
            onClick={() =>
              window.location.replace(
                `${window.location.origin}/supplier/new-card`
              )
            }
          >
            {t("Add")}
            <span className="ml-3">
              <AddIcon />
            </span>
          </Button>
        )}
      </div>
      <div className="p-4 bg-white">
        <div className="flex justify-between items-center mb-3">
          <h1 className="text-darkGrey text-lg font-bold ">
            {t("Cards")} {t("List")}
          </h1>
          <div className="flex gap-2 items-center">
            <Input
              name="search"
              placeholder="Search by card"
              className="mb-3"
              onChange={(e) => handleCardSearch(e.target.value)}
            />
            <FilterIcon className="cursor-pointer" onClick={handleClick} />

            <Popover
              id={"id"}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              style={{ marginTop: "5px" }}
            >
              <div className="shadow p-2 bg-white w-[150px]">
                <div className="flex flex-col">
                  <span
                    className="py-2 text-grey text-sm cursor-pointer"
                    onClick={() => getStatusCardList("")}
                  >
                    {t("All")}
                  </span>
                  <span
                    className="py-2 text-grey text-sm cursor-pointer"
                    onClick={() => getStatusCardList("pending")}
                  >
                    {t("Pending")}
                  </span>
                  <span
                    className="py-2 text-grey text-sm cursor-pointer"
                    onClick={() => getStatusCardList("paid")}
                  >
                    {t("Accepted")}
                  </span>
                  <span
                    className="py-2 text-grey text-sm cursor-pointer"
                    onClick={() => getStatusCardList("declined")}
                  >
                    {t("Declined")}
                  </span>
                </div>
              </div>
            </Popover>
            <Button size="small" onClick={getCardList}>
              <img src={refreshImage} alt="" className="mr-2" />
              {t("Refresh")}
            </Button>

            {/* <Input
              name="keyword"
              placeholder="Search by keyword"
              inputClassName="h-9"
              variant="solid"
            /> */}
          </div>
        </div>
        {isLoading && <OverlayLoader />}
        <Table
          tableLayout="fixed"
          columns={columns as any}
          emptyText={t("No data found")}
          data={cardList}
          rowKey="id"
          scroll={{ x: 1000 }}
          sticky={true}
          className="matrix"
          onHeaderRow={() => ({
            className: "header-title",
          })}
        />
        <Pagination
          className="w-full mt-10"
          count={Math.ceil(totalCards / pageSize)}
          onChange={handlePageChange}
        />
      </div>
      <Modal
        open={activeDeletedId ? true : false}
        onClose={() => setActiveDeletedId("")}
      >
        <ConfirmationCard
          title={t("Delete This Item?")}
          onCancel={() => setActiveDeletedId("")}
          onDelete={handleDelete}
          description={t(
            "Are you sure about deleting this card? This cannot be undone."
          )}
        />
      </Modal>
      <Modal
        open={activeCardDetail ? true : false}
        onClose={() => setActiveCardDetail(null)}
        modalClass="w-full"
      >
        <CardDetail detail={activeCardDetail} />
      </Modal>
    </div>
  );
};
export default CardManagement;
